import React from 'react';
import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import { ICommerceApiSettings } from '@msdyn365-commerce/core-internal';

interface IKeyFeaturesIconsProps {
    icons: {
        ImageTitle: string;
        ImageName: string;
    }[];
    apiSettings: ICommerceApiSettings;
}

export function KeyFeaturesIcons(props: IKeyFeaturesIconsProps) {
    return (
        <>
            {props.icons && props.icons.length > 0 && (
                <div className='key-features-icons'>
                    {props.icons.map(icon => {
                        let iconUrl = generateImageUrl(icon.ImageName, props.apiSettings);
                        iconUrl = iconUrl?.replace('fileName=/', 'fileName=');

                        return (
                            <div key={icon.ImageName}>
                                <img src={iconUrl} alt={icon.ImageTitle} />
                                <span>{icon.ImageTitle}</span>
                            </div>
                        );
                    })}
                </div>
            )}
        </>
    );
}
